import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { ApiService } from 'app/core/services/api.service';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
})
export class UserComponent implements OnInit{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */
    user: any;
    imagePathSrc: string;

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private api: ApiService,
        private _authService: AuthService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this._authService.currentUser.subscribe({
            next: (res: any) => {
                if (res) {
                    this.user = res;
                    console.log('user', this.user);
                }
                this._changeDetectorRef.detectChanges();
            },
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign out
     */
    signOut(): void {
        this.api.getData('logout').subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.api.refreshData.postMessage('logout');
                    this.api.isLoggedOut.next(1);
                    localStorage.removeItem('currentUser');
                    localStorage.removeItem('token');
                    localStorage.removeItem('member_id');
                    localStorage.removeItem('active_module');
                    localStorage.removeItem('selectedIndex');
                    localStorage.removeItem('status');
                    this._router.navigate(['/auth/signin']);
                } else {
                }
            },
            error: (err) => {
                console.log('err', err);
            },
        });

        setTimeout(() => {
            this.api.isLogginFirstTime.next(false);
            localStorage.removeItem('token');
            this._authService.logout();
        }, 500);
    }

    moveToProfile() {
        this._router.navigateByUrl('/manage/profile')
    }
}
